import {
	Box,
	Card,
	CardHeader,
	CardContent,
	CardActionArea,
	Typography,
	Chip,
	Avatar,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	ListItemIcon,
	Checkbox,
	IconButton,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	FormControlLabel,
	Tooltip,
} from "@mui/material";

import {
	ExpandMore,
	MoreHoriz,
	RadioButtonUnchecked,
	CheckCircle,
} from "@mui/icons-material";

import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const PeopleCard = ({ resourceName, username, image }) => {
	const token = useSelector((state) => state.auth.token);
	const [expanded, setExpanded] = useState(false);
	const [checked, setChecked] = useState([]);
	const [actionItems, setActionItems] = useState([]);
	const [mostRecentMeeting, setMostRecentMeeting] = useState("");

	const handleAccordionChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};

	const navigate = useNavigate();

	const handleToggle = (value) => () => {
		const currentIndex = checked.indexOf(value);
		const newChecked = [...checked];

		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			newChecked.splice(currentIndex, 1);
		}

		setChecked(newChecked);
	};

	const handleClick = () => {
		// Navigate to the person's page
		navigate(`/people/${resourceName}`);
	};

	const handleCompleteActionItems = async () => {
		// submit them
		let actionItemsObj = {};
		checked?.forEach((index) => {
			const actionItem = actionItems[index];
			actionItemsObj[actionItem?.item] = {
				item: actionItem?.item,
				fromId: actionItem?.fromId,
				date: actionItem?.dueDate,
			};
		});

		try {
			const response = await fetch(
				`${process.env.REACT_APP_PORT}/actionItems/completeActionItems`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`,
					},
					body: JSON.stringify({ actionItems: actionItemsObj }),
				}
			);

			const data = await response.json();

			// get all action items not completed and keep in action items list
			const actionItemsNew = actionItems?.filter(
				(actionItem) =>
					!data?.actionItemsCompleted.some((actionItem2) => {
						return (
							actionItem.fromId === actionItem2.fromId &&
							actionItem.title === actionItem2.title &&
							actionItem.item === actionItem2.item
						);
					})
			);

			if (response.status === 200) {
				setActionItems(actionItemsNew);
			}
		} catch (error) {
			console.log("response is", error);
		}
	};

	useEffect(() => {
		const getMutualActionItems = async () => {
			try {
				const url = new URL(
					`${process.env.REACT_APP_PORT}/actionItems/getMutualActionItems/${username}`
				);
				const response = await fetch(url, {
					method: "GET",
					headers: { Authorization: `Bearer ${token}` },
				});

				const data = await response.json();
				if (response.status === 200) {
					const { actionItems, missedActionItems } = data;
					console.log("action items are", actionItems);
					setActionItems(actionItems);
				}
			} catch (error) {
				console.log("error is", error);
				setActionItems([]);
			}
		};
		getMutualActionItems();
	}, []);

	useEffect(() => {
		const fetchUserInteractions = async () => {
			const response = await fetch(
				`${process.env.REACT_APP_PORT}/people/getUserInteractions/${username}`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`,
					},
				}
			);
			const data = await response.json();
			const interactions = data?.interactions?.filter((interaction) => {
				return interaction.type === "gcal";
			});

			const recent =
				interactions?.length > 0
					? interactions[0]?.title
					: "No previous meetings";
			setMostRecentMeeting(recent);
		};
		fetchUserInteractions();
	}, []);

	return (
		<Card
			sx={{
				height: "300px",
				width: "250px",
				borderRadius: "10px",
				background:
					"linear-gradient(179.2deg, #3B57B8 -105.91%, #DCE1FF 63.24%)",
			}}
		>
			<CardActionArea disableRipple>
				<CardContent
					component={Box}
					display="flex"
					flexDirection="column"
					gap="2rem"
				>
					<Box display="flex" alignItems={"center"}>
						<Avatar src={image} />
						<Tooltip title={username} onClick={handleClick}>
							<Typography
								sx={{
									p: "1rem",
								}}
								variant="h5"
								noWrap
							>
								{username}
							</Typography>
						</Tooltip>
					</Box>
					<Box>
						<Typography variant="h6">Previous Meeting:</Typography>
						<Typography variant="h6" fontWeight="700">
							{mostRecentMeeting}
						</Typography>
					</Box>

					<Box overflow="auto" maxHeight="100px">
						<Accordion
							sx={{ margin: "auto" }}
							onClick={(e) => e.stopPropagation()}
							disabled={actionItems?.length === 0}
						>
							<AccordionSummary
								expandIcon={<ExpandMore onClick={handleAccordionChange} />}
							>
								<Typography>{`Action Items ( ${actionItems?.length} )`}</Typography>
							</AccordionSummary>

							<AccordionDetails>
								<Box overflow="auto">
									<List
										sx={{
											height: "100%",
											width: "100%",
											maxHeight: "400px",
											bgcolor: "background.paper",
										}}
									>
										{actionItems?.map((actionItem, i) => (
											<ListItem key={i} disablePadding overflow="auto">
												<ListItemButton
													onClick={handleToggle(i)}
													dense
													disableRipple
												>
													<ListItemIcon>
														<Tooltip
															title={actionItem?.item}
															placement="left-start"
														>
															<FormControlLabel
																control={
																	<Checkbox
																		icon={<RadioButtonUnchecked />}
																		checkedIcon={<CheckCircle />}
																		edge="start"
																		checked={checked.indexOf(i) !== -1}
																		onChange={handleToggle(i)}
																		tabIndex={-1}
																		disableRipple
																	/>
																}
																label={actionItem?.item}
															/>
														</Tooltip>
													</ListItemIcon>
												</ListItemButton>
											</ListItem>
										))}
									</List>
								</Box>
							</AccordionDetails>
						</Accordion>
					</Box>
					<Box display="flex" alignItems="center" justifyContent="end">
						<Tooltip
							title={
								checked.length > 1
									? `Complete ${checked.length} action items`
									: "Complete 1 action item"
							}
						>
							<IconButton
								disabled={checked.length === 0}
								onClick={handleCompleteActionItems}
							>
								<CheckCircle />
							</IconButton>
						</Tooltip>
					</Box>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};

export default PeopleCard;
